import { Stack } from '@mui/material'
import Label from 'components/Label'
import React from 'react'
import { Control, Controller } from 'react-hook-form'
import 'react-quill/dist/quill.snow.css'
import ReactQuill from 'react-quill'
import './style.css'

type InputTextEditorProps = {
  name: string
  control: Control<any>
}

const InputTextEditor: React.FC<InputTextEditorProps> = ({ name, control }) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <Stack direction='column'>
          <ReactQuill
            style={{
              backgroundColor: 'white',
            }}
            theme='snow'
            value={value}
            modules={{
              toolbar: [
                'bold',
                'italic',
                'underline',
                'strike',
                { list: 'ordered' },
                { list: 'bullet' },
                { list: 'check' },
                { indent: '-1' },
                { indent: '+1' },
              ],
            }}
            onChange={(value) => onChange(value)}
          />
          {error && error.message && (
            <Label text={error.message} sx={{ mt: 0.5, fontSize: 12, color: 'error.main' }} />
          )}
        </Stack>
      )}
    />
  )
}

export default InputTextEditor
